// Mock data for G Developments website

export const navigationLinks = [
  { name: 'Home', href: '/' },
  { name: 'Projects', href: '/projects' },
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' }
];

export const companyInfo = {
  name: 'G Developments',
  logo: 'https://customer-assets.emergentagent.com/job_ef21eb0a-7d75-40d4-b754-fa7eefc4bb7f/artifacts/3prfonjw_G%20Developments%20logo.svg',
  phone: '+201080639209',
  phone2: '+201030000550',
  email: 'info@thegdevelopments.co',
  // WhatsApp numbers for rotation
  whatsappNumbers: ['201080639209'],
  whatsapp: '201080639209', // Primary WhatsApp number
  address: 'Cairo, Egypt'
};

export const disclaimerText = 'Disclaimer: This website is managed by a G Developments sales team to assist clients with accurate information and tailored property guidance.';

export const authorityHeadline = "G Developments is one of Egypt's leading real estate developers.";

export const impactMetrics = [
  { value: '30,000+', label: 'Units Sold' },
  { value: '50,000+', label: 'Satisfied Clients' },
  { value: '#1', label: 'Developer on the North Coast' }
];

export const projectsPortfolio = [
  {
    id: 'newgiza',
    name: 'NEWGIZA',
    logo: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/xe6dq1qe_NEWGIZA%20Logo.svg',
    image: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/4au8vzz8_Screenshot%202026-01-21%20at%202.46.20%E2%80%AFPM.png',
    href: '/projects/newgiza'
  },
  {
    id: 'newkairo',
    name: 'NEWKAIRO',
    logo: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/gteb5jbo_Newkairo%20Logo%202.svg',
    image: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/7f19lccz_Screenshot%202025-02-05%20at%202.38.36%E2%80%AFPM.png',
    href: '/projects/newkairo'
  },
  {
    id: 'seashell',
    name: 'Seashell',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_luxury-realestate-8/artifacts/s9jnc6px_Screenshot%202026-01-21%20at%203.32.12%E2%80%AFPM.png',
    href: '/projects/seashell'
  },
  {
    id: 'playa-ghazala',
    name: 'Playa Ghazala',
    logo: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/3qqo7umv_PLAYA%20Logo.svg',
    image: 'https://customer-assets.emergentagent.com/job_egyptian-real-estate/artifacts/pq714a48_IMG_2460.jpg',
    href: '/projects/playa-ghazala'
  },
  {
    id: 'seashell-ras-el-hekma',
    name: 'Seashell Ras El Hekma',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/is53qc9i_Screenshot%202025-01-23%20at%204.18.30%E2%80%AFPM.png',
    href: '/projects/seashell-ras-el-hekma'
  },
  {
    id: 'playa-ras-el-hekma',
    name: 'Playa Ras El Hekma',
    logo: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/3qqo7umv_PLAYA%20Logo.svg',
    image: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/xoho5isu_Screenshot%202024-12-11%20at%207.10.26%E2%80%AFPM.png',
    href: '/projects/playa-ras-el-hekma'
  },
  {
    id: 'ivy',
    name: 'IVY',
    logo: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/bymrd6s8_IVY%20Logo.svg',
    image: 'https://customer-assets.emergentagent.com/job_luxury-realestate-8/artifacts/wknnk7av_Screen%20Shot%202024-09-30%20at%2012.21.05%20PM.png',
    href: '/projects/ivy'
  },
  {
    id: 'artlife',
    name: 'Artlife',
    logo: 'https://customer-assets.emergentagent.com/job_egypt-realty-1/artifacts/o0egcmjq_Artlife%20Logo%201.svg',
    image: 'https://customer-assets.emergentagent.com/job_89d8d850-1b58-4ed7-a486-515f1e5d44ca/artifacts/4b8bil5c_Screenshot%202024-12-09%20at%201.38.15%E2%80%AFPM.png',
    href: '/projects/artlife'
  },
  {
    id: 'hacienda-red',
    name: 'Hacienda Red',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_89d8d850-1b58-4ed7-a486-515f1e5d44ca/artifacts/kk8snfsr_7cc30eb0-89e5-47f6-bfc8-8a8abf7f28c2.JPG',
    href: '/projects/hacienda-red'
  },
  {
    id: 'twilight-residences',
    name: 'Twilight Residences',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_89d8d850-1b58-4ed7-a486-515f1e5d44ca/artifacts/ko1kgx7a_Screen%20Shot%202024-09-30%20at%2012.13.52%20PM.png',
    href: '/projects/twilight-residences'
  },
  {
    id: 'the-collection',
    name: 'The Collection',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_89d8d850-1b58-4ed7-a486-515f1e5d44ca/artifacts/md27i7kw_Screenshot%202025-01-19%20at%201.22.39%E2%80%AFPM.png',
    href: '/projects/the-collection'
  },
  {
    id: 'ein-bay',
    name: 'Ein Bay',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_property-portfolio-14/artifacts/zmjusm8c_IMG_1245.JPG',
    href: '/projects/ein-bay'
  }
];

export const heroContent = {
  headline: 'Crafting Exceptional Living Spaces',
  subheadline: 'Premium real estate developments designed for modern lifestyles in Egypt\'s most prestigious locations.',
  cta: 'Explore Our Projects'
};

export const featuredProjects = [
  {
    id: 1,
    name: 'The Residence',
    location: 'New Cairo',
    type: 'Luxury Apartments',
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80'
  },
  {
    id: 2,
    name: 'Marina Heights',
    location: 'North Coast',
    type: 'Beachfront Villas',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
  },
  {
    id: 3,
    name: 'Garden Terraces',
    location: '6th of October',
    type: 'Family Compounds',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80'
  }
];

export const footerLinks = {
  quickLinks: [
    { name: 'About Us', href: '/about' },
    { name: 'Our Projects', href: '/projects' },
    { name: 'Articles', href: '/articles' },
    { name: 'Contact', href: '/contact' }
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' }
  ]
};

export const legalDisclaimer = 'All trademarks and project names belong to their respective owners.';
